import * as d3 from 'd3'

export default {
  methods: {
    
    call_Link(selection, data_) {
      if (this.chart.link !== 'Y') return
      selection
      .on('mouseover', function() {
        d3.select(this).transition().duration(100)
        .attr('transform', `translate(${data_.x}, 40) scale(1.3)`).style('fill', '#EC407A')
      })
      .on('mouseout', function(){
        d3.select(this).transition().duration(100)
        .attr('transform', `translate(${data_.x}, 40) scale(1)`).style('fill', '#757575')
      })
      .on('click', () => {

        let dataSource = {}

        Object.keys(this.keys).forEach(d=>{
          dataSource = {...dataSource, [d]: data_[this.keys[d]]}
        })

        let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)

        if(!request_) return

        // set for filterString 
        let filterString_ = ''

        if (this.cutoff && this.filters) {
          filterString_ += this.filters[`${data_.WEEK}`].replaceAll('@cutoff', `'${this.cutoff}'`)
        }

        // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
        if(request_.iFilters.filterString) {
          request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
        } else {
          request_.iFilters.filterString = filterString_||''
        }

        // combine filterString and inputFilter &&& emit request-action
        request_ = {...request_,
          filters : {
            ...this.FilterValues,
            ...request_.filters,
          },
          iFilters: { 
            filterString : request_.iFilters.filterString||'',
            inputFilter : request_.iFilters.inputFilter,},
        }
        this.$emit('request-action', request_)
      })
    },

  }
}